var _defs, _path, _rect, _path2, _rect2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 52.195,
    viewBox: "0 0 166 52.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 166,
    height: 52.195,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M564.893,98.243V72.053h-3.531V68.076h11.5v3.977h-3.393v26.19Z",
    transform: "translate(-486.641 -59.015)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 4.594,
    height: 30.167,
    transform: "translate(87.771 9.061)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M720.5,98.243V68.076h5.708l4.285,22.042,4.028-22.042h5.742V98.243h-4.1V87l.171-10.318-4.063,21.425h-3.651L724.39,76.681,724.562,87V98.243Z",
    transform: "translate(-624.597 -59.015)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 4.594,
    height: 30.167,
    transform: "translate(119.22 9.061)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M952.4,98.243V94.164l6.256-22.128h-5.691V68.076h10.507V71.8l-6.256,22.488h6.119v3.959Z",
    transform: "translate(-825.626 -59.015)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1052.376,98.243V68.076h10.113v3.959h-5.519v8.776h5.245v3.874h-5.245v9.6h5.725v3.959Z",
    transform: "translate(-912.299 -59.015)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1148.621,98.243V68.076h6.771q3.325,0,4.825,1.963a9.423,9.423,0,0,1,1.5,5.785l.017,13.609q0,4.56-1.508,6.685t-4.988,2.125Zm4.594-3.565h1.509a2.089,2.089,0,0,0,1.842-.823,5.621,5.621,0,0,0,.574-3.017l-.017-14.9a7.1,7.1,0,0,0-.574-3.342,2.1,2.1,0,0,0-1.98-.994h-1.354Z",
    transform: "translate(-995.733 -59.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M463.439,190.6v13.859h4.594V191.073Z",
    transform: "translate(-401.753 -165.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M475.172,70.21q-1.295-2.134-4.808-2.134h-6.925V85.545l4.594.8h2.485q3.462,0,4.739-2.322a14.464,14.464,0,0,0,1.277-6.814v-.634a12.916,12.916,0,0,0-1.362-6.368m-3.231,6.95a13.729,13.729,0,0,1-.437,4.276,1.811,1.811,0,0,1-1.894,1.123h-1.577V71.607h1.611a1.773,1.773,0,0,1,1.825,1.149,11.607,11.607,0,0,1,.471,3.822Z",
    transform: "translate(-401.753 -59.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M2.286,68.559H0V82.793H5V80.827H2.286Z",
    transform: "translate(0 -59.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M44.371,94.858a2.749,2.749,0,0,0,.61-1.06,7.724,7.724,0,0,0,.26-2.37v-.71H43v1.127c0,.422-.011.76-.032,1a1.579,1.579,0,0,1-.237.689c-.071.112-.24.168-.5.168a.646.646,0,0,1-.59-.308,3.573,3.573,0,0,1-.205-1.552V89.553h3.82v-2.64a5.146,5.146,0,0,0-.64-2.792,2.564,2.564,0,0,0-2.321-1c-2.081,0-3.137,1.263-3.137,3.753v4.476a7.66,7.66,0,0,0,.373,2.619,2.551,2.551,0,0,0,2.676,1.59,3.013,3.013,0,0,0,2.162-.7m-2.09-9.926a.547.547,0,0,1,.571.383A4.5,4.5,0,0,1,43,86.7v1.468H41.43V86.76c0-.256.005-.464.016-.621.041-.812.311-1.207.835-1.207",
    transform: "translate(-33.948 -72.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M96.221,81.064h-.07a2.336,2.336,0,0,1-.956-.112c-.122-.066-.184-.229-.184-.483V72.516h1.169V70.838H95.012V68.5H92.75v2.338h-.977v1.677h.977v8.322a2.3,2.3,0,0,0,.4,1.532,2.048,2.048,0,0,0,1.557.452h1.511Z",
    transform: "translate(-79.558 -59.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M130.667,73.483h1.371l1.1-3.556,0-2.269h-2.934v2.39h1.208Z",
    transform: "translate(-112.88 -58.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M162.522,94.775a3.418,3.418,0,0,0,.715-2.353,4.94,4.94,0,0,0-1.776-3.647l-1.136-1.032a2.376,2.376,0,0,1-.828-1.72,1.3,1.3,0,0,1,.188-.8.71.71,0,0,1,.579-.223.561.561,0,0,1,.549.356,2.982,2.982,0,0,1,.178,1.184V87.4h2.037v-.726a4.374,4.374,0,0,0-.668-2.723,2.576,2.576,0,0,0-2.116-.831c-1.927,0-2.9,1.015-2.9,3.017a4.261,4.261,0,0,0,1.5,3.229c.055.055.24.223.568.515.419.374.5.45.516.464a2.958,2.958,0,0,1,1.083,2.175,1.745,1.745,0,0,1-.18.926.629.629,0,0,1-.567.254c-.5,0-.747-.515-.747-1.532V91.127H157.38v.847a4.263,4.263,0,0,0,.713,2.731,2.731,2.731,0,0,0,2.216.862,2.856,2.856,0,0,0,2.214-.792",
    transform: "translate(-136.397 -72.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M64.02,185.827a2.911,2.911,0,0,0-2.486,1.053,5.016,5.016,0,0,0-.779,3.021v6.126a5.661,5.661,0,0,0,.762,3.264,2.49,2.49,0,0,0,2.135,1.074,2.272,2.272,0,0,0,1.354-.421,1.9,1.9,0,0,0,.688-.908l.281,1.185h1.086v-7.835H63.966v1.7h1.081v1.828a5.415,5.415,0,0,1-.247,1.943.8.8,0,0,1-.793.542.725.725,0,0,1-.748-.5,6.072,6.072,0,0,1-.2-1.9v-6.11a4.089,4.089,0,0,1,.225-1.63.747.747,0,0,1,.734-.43.716.716,0,0,1,.707.355,3.167,3.167,0,0,1,.2,1.329v1.543h2.142v-1.071a7.791,7.791,0,0,0-.341-2.562,2.545,2.545,0,0,0-2.7-1.592",
    transform: "translate(-52.668 -161.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M118.755,201.589c-2.081,0-3.137,1.263-3.137,3.753v4.476a7.66,7.66,0,0,0,.373,2.619,2.551,2.551,0,0,0,2.676,1.59,3.013,3.013,0,0,0,2.162-.7,2.749,2.749,0,0,0,.61-1.06,7.724,7.724,0,0,0,.26-2.37v-.71h-2.238v1.127c0,.422-.011.76-.032,1a1.579,1.579,0,0,1-.237.689c-.071.112-.24.168-.5.168a.646.646,0,0,1-.59-.308,3.573,3.573,0,0,1-.205-1.552v-2.292h3.82v-2.64a5.146,5.146,0,0,0-.64-2.792,2.564,2.564,0,0,0-2.321-1m-.867,3.641c0-.256.005-.464.016-.621.041-.812.311-1.207.835-1.207a.547.547,0,0,1,.571.383,4.5,4.5,0,0,1,.152,1.389v1.468h-1.574Z",
    transform: "translate(-100.229 -174.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M172.608,199.534a2.337,2.337,0,0,1-.956-.112c-.122-.066-.184-.229-.184-.483v-7.954h1.169v-1.677h-1.169V186.97h-2.262v2.338h-.977v1.677h.977v8.322a2.3,2.3,0,0,0,.4,1.532,2.047,2.047,0,0,0,1.557.452h1.511v-1.757Z",
    transform: "translate(-145.838 -162.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M249.668,23.97C247.535,9.606,239.394-1.086,231.486.088S218.9,13.86,221.031,28.224s10.274,25.057,18.182,23.882S251.8,38.335,249.668,23.97M240.59,46.7c-5.845.868-11.956-7.673-13.65-19.078S228.611,6.265,234.455,5.4s11.956,7.673,13.65,19.078S246.435,45.828,240.59,46.7",
    transform: "translate(-191.163 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M310.814,92.108c-1.271-8.553-5.845-14.961-10.218-14.311s-6.887,8.11-5.617,16.663,5.845,14.961,10.218,14.311,6.887-8.11,5.616-16.663m-4.827,11.27c-2.491.37-5.2-3.953-6.043-9.655s.485-10.625,2.976-10.995,5.2,3.953,6.043,9.655-.485,10.625-2.976,10.995",
    transform: "translate(-255.431 -67.402)",
    fill: "#f37721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M361.294,169.979c-.992.147-2.07-1.574-2.407-3.846s.193-4.232,1.185-4.38,2.07,1.574,2.407,3.846-.193,4.232-1.185,4.38",
    transform: "translate(-311.029 -140.216)",
    fill: "#f37721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M388.045,169.279l-14.259.9.487-1.947-2,1.922a1.254,1.254,0,0,0-.006,1.8l1.985,1.931-.464-1.763,14.812,1.032Z",
    transform: "translate(-322.385 -145.837)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgo);
export default __webpack_public_path__ + "static/media/LGO.daf122d5847020c9c5947b5b8cea639e.svg";
export { ForwardRef as ReactComponent };